import enviro from 'enviro';
import { useEffect } from 'react';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import { getGoogleContactsSyncAlertValue } from '../utils/getGoogleContactsSyncAlertValue';
// @ts-expect-error Untyped module
import Cookies from 'js-cookie';
import { jsx as _jsx } from "react/jsx-runtime";
export let GoogleContactsSyncAlertType;
(function (GoogleContactsSyncAlertType) {
  GoogleContactsSyncAlertType["success"] = "success";
  GoogleContactsSyncAlertType["warning"] = "warning";
})(GoogleContactsSyncAlertType || (GoogleContactsSyncAlertType = {}));
export const getGoogleContactsAlertMessageElement = alertType => {
  if (alertType === GoogleContactsSyncAlertType.warning) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: `app.googleContactsSyncAlert.${GoogleContactsSyncAlertType.warning}.message`
    });
  }
  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: `app.googleContactsSyncAlert.${GoogleContactsSyncAlertType.success}.message`
  });
};
const GoogleContactsSyncAlert = () => {
  useEffect(() => {
    const googleContactsSyncAlertValue = getGoogleContactsSyncAlertValue();
    if (googleContactsSyncAlertValue && googleContactsSyncAlertValue in GoogleContactsSyncAlertType) {
      FloatingAlertStore.addAlert({
        message: getGoogleContactsAlertMessageElement(googleContactsSyncAlertValue),
        titleText: I18n.text(`app.googleContactsSyncAlert.${googleContactsSyncAlertValue}.title`),
        type: googleContactsSyncAlertValue,
        id: 'GOOGLE_CONTACTS_SYNC_ALERT'
      });
      Cookies.remove('googleContactsSyncAlert', {
        domain: enviro.isQa() ? '.hubspotqa.com' : '.hubspot.com',
        path: '/'
      });
    }
  }, []);
  return null;
};
export default GoogleContactsSyncAlert;